import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HotelsResultCardComponent } from './hotels-result-card.component';
import { MatCardModule } from '@angular/material/card';
import { ButtonModule } from 'src/app/libs/ui/components/button/button.module';
import { StarsRatingModule } from 'src/app/libs/ui/components/stars-rating/stars-rating.module';
import { NgImageSliderModule } from 'ng-image-slider';
import { MatDividerModule } from '@angular/material/divider';
import { CurrencyExchangeConverterModule } from 'src/app/libs/common/pipes/currency-exhange-converter/currency-exhange-convertermodule';
import { AbsModule } from 'src/app/libs/common/pipes/abs/abs.module';

@NgModule({
    declarations: [
        HotelsResultCardComponent
    ],
    exports: [
        HotelsResultCardComponent,
    ],
    imports: [
        CommonModule,
        MatCardModule,
        ButtonModule,
        StarsRatingModule,
        NgImageSliderModule,
        MatDividerModule,
        CurrencyExchangeConverterModule,
        AbsModule
    ]
})
export class HotelsResultCardModule { }
